export default __webpack_public_path__ + "static/media/limit_90.c7072462.svg";